import React from "../../../_snowpack/pkg/react.js";
import {Link} from "../../../_snowpack/pkg/react-router-dom.js";
import styles from "./NavBar.module.css";
const NavBar = () => {
  return /* @__PURE__ */ React.createElement("nav", {
    className: styles.navbar
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h1", {
    className: styles.nameContainer
  }, "Munshi Nadim")), /* @__PURE__ */ React.createElement("div", {
    className: styles.linkContainer
  }, /* @__PURE__ */ React.createElement("ul", {
    className: styles.linkListContainer
  }, /* @__PURE__ */ React.createElement("li", {
    className: styles.link
  }, /* @__PURE__ */ React.createElement(Link, {
    to: "/"
  }, "Home")), /* @__PURE__ */ React.createElement("li", {
    className: styles.link
  }, /* @__PURE__ */ React.createElement(Link, {
    to: "/about-me"
  }, "About Me")), /* @__PURE__ */ React.createElement("li", {
    className: styles.link
  }, /* @__PURE__ */ React.createElement(Link, {
    to: "/contact-me"
  }, "Contact Me")), /* @__PURE__ */ React.createElement("li", {
    className: styles.link
  }, /* @__PURE__ */ React.createElement(Link, {
    to: "/my-projects"
  }, "My Projects")))));
};
export default NavBar;
